import { useLocalStorage } from "usehooks-ts"
import { UserLocalStorageKey } from "src/types"

export type ZoomLevel = 1 | 3 | 6 | 12 | 24
export const zoomLevels: ZoomLevel[] = [
  1,
  3,
  6,
  12,
  24,
]

const defaultZoom = 3

export function useGraphZoom() {
  return useLocalStorage<ZoomLevel>(
    UserLocalStorageKey.GraphZoom,
    defaultZoom,
  )
}
